import React, {useMemo, useState} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Dialog} from "../../../../designSystem/components/Dialog";
import {Dropdown} from "../../../../designSystem/components/Dropdown";

import {BsrsForm} from "../BsrsForm";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {LoadingDialog} from "../../../../components/DialogLoading";

import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {useCreateBsrsSurvey} from "../../hooks/useCreateBsrsSurvey";
import {Typography} from "../../../../designSystem/components/Typography";

const GENDERS = ['男', '女', '多元性別']

export const BsrsFormFeature = ({
  onSubmittedForm,
  answers,
  score,
  onChangeAnswers,
  onChangeScore,
}) => {
  const [age, setAge] = useState<string>('');
  const [gender, setGender] = useState<string>('');
  const { isLoading, submit } = useCreateBsrsSurvey({
    age,
    gender,
    score,
    answers,
    onCompleted: onSubmittedForm
  } )

  const isFormValid = useMemo(() => {
    return (age && gender)
  }, [age, gender]);

  return (
    <FormPageLayout
      height={NAVIGATION_BAR_HEIGHT.LARGE}
      body={
        <React.Fragment>
          <div className="p-6 flex flex-col flex-1 justify-between">
            <BsrsForm
              onChangeAnswer={(tempAnswer, tempScore) => {
                onChangeAnswers(tempAnswer)
                onChangeScore(tempScore)
              }}
            />
            <div className="flex flex-row justify-between gap-4">
              <div className="flex flex-1 flex-col gap-2">
                <Typography variant="bodyBold">
                  年齡
                </Typography>
                <BaseInput
                  onChange={(e) => setAge(e.target.value)}
                  value={age}
                  type="number"
                />
              </div>
              <div className="flex flex-1 flex-col gap-2">
                <Typography variant="bodyBold">
                  性別
                </Typography>
                <Dropdown
                  className="flex flex-1"
                  options={GENDERS}
                  dataSelected={gender}
                  hasDiv={false}
                  disabled={false}
                  onChange={e => setGender(e.target.value)}
                  text=""
                />
              </div>
            </div>
          </div>
          <Dialog isOpen={isLoading}>
            <LoadingDialog label="請稍候" />
          </Dialog>
        </React.Fragment>
      }
      footer={
        <ActionButton
          fullWidth
          onClick={submit}
          label="送出"
          disabled={!isFormValid}
        />
      }
    />
  )
}